module.exports = __webpack_public_path__ + "img/A5.fb378b7c.png";